<style lang="scss">
  @import '../public/scss/custom-vars.scss';
  @import '~bootstrap/scss/bootstrap.scss';
  @import '~bootstrap-vue/src/index.scss';
  @import '../public/scss/style.scss';
</style>
<template>
  <div id="app">
    <RwvHeader />
    <router-view></router-view>
  </div>
</template>
<script>
import RwvHeader from "@/components/TheHeader";
import { mapGetters } from "vuex";
import store from "@/store";
export default {
  name: "Index",
  created() {
    window.addEventListener("beforeinstallprompt", event => {
      event.preventDefault();
      window.deferredPrompt = event;
      store.dispatch("promptToggle");
    });
  },
  data(){
    return {
      orderId: null
    }
  },
  computed: {
    ...mapGetters(["currentUser"])
  },
  methods: {
    setOrderId(orderId){
      this.orderId = orderId;
    }
  },
  components: {
    RwvHeader
  }
};
</script>